import React from "react";
import {Box, Card, CardActionArea, CardContent, Stack, Typography} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";

export default function DashboardKpiCard({title, value, caption, icon, to}) {
    const content = (
        <CardContent>
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                <Box>
                    <Typography variant="overline" color="text.secondary" sx={{lineHeight: 1.2, fontWeight: 700}}>
                        {title}
                    </Typography>
                    <Typography
                        variant="h4"
                        fontWeight={800}
                        sx={{fontSize: {xs: "1.5rem", sm: "2.125rem"}}}
                    >
                        {value}
                    </Typography>
                    {caption && (
                        <Typography variant="caption" color="text.secondary">
                            {caption}
                        </Typography>
                    )}
                </Box>
                {icon}
            </Stack>
        </CardContent>
    );

    return (
        <Card
            sx={{
                borderRadius: 3,
                height: "100%",
                boxShadow: "0 6px 24px rgba(0,0,0,0.06)",
                background: "linear-gradient(135deg, rgba(255,165,0,0.10) 0%, rgba(0,0,0,0.04) 100%)",
            }}
        >
            {to ? (
                <CardActionArea component={RouterLink} to={to} sx={{height: "100%", alignItems: "stretch"}}>
                    {content}
                </CardActionArea>
            ) : (
                content
            )}
        </Card>
    );
}
